import React from 'react';
import { connect } from 'react-redux';
import SectionHeader from './SectionHeader';
import ControlHeader from './ControlHeader';

class Select extends React.Component {
  //Defect: in case that items change, store value should reset
  //componentWillReceiveProps(nextProps) {
  // if (nextProps.item != this.props.items) {
  //   const newValue = document.getElementById(this.props.name).value;
  //   this.props.dispatch({ type: 'select', name: this.props.name, value: newValue });
  // }
  //}
  componentWillMount() {
    const p = this.props;
    const v = (p.value) || p.default || ((p.placeHolder || !p.items || p.items.length == 0) ? 0 : p.items[0].id);
    this.props.dispatch({ type: 'select', name: p.name, value: v });
  }
  componentDidMount() {
    const p = this.props;
    if (p.onChange) {
      const v = p.value;
      p.onChange(v);
    }
  }
  componentWillReceiveProps(props) {
    const p = props;
    if (p.error)
      this.setState({ error: p.error });
    else {
      this.setState({ error: null });

    }
  }

  change = e => {
    const p = this.props;
    if (p.onChange)
      p.onChange(e.target.value);
    p.dispatch({ type: 'select', name: p.name, value: e.target.value });
    if (p.name == 'providedIdentificationId')
      p.dispatch({ type: 'textbox', name: 'identificationVerificationInput', value: '' });
  }
  render() {
    const p = this.props;
    const e = this.state && this.state.error;
    const select = (<select id={p.id} name={p.name} className="form-control" value={p.value} onChange={this.change} onBlur={this.blur} disabled={p.disabled}>
      {p.placeHolder ? <option value="">{p.placeHolder}</option> : null}
      {p.items.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
    </select>);
    return (
      <div className={p.error ? 'has-error' : ''}>
        {this.props.isControl ? <ControlHeader {...p} /> : <SectionHeader {...p} />}
        {p.customClass ?
          <div className="row"><div className={p.customClass}>{select}</div></div>
          :
          <div>{select}</div>
        }
        {e ? <label className="control-label has-error validationMessage">{e}</label> : null}
      </div>
    );
  }
}
Select.propTypes = {
  name: React.PropTypes.string.isRequired,
  id: React.PropTypes.string,
  title: React.PropTypes.string,
  items: React.PropTypes.array.isRequired,
  isControl: React.PropTypes.bool,
  placeHolder: React.PropTypes.string,
  onChange: React.PropTypes.func,
  dispatch: React.PropTypes.func
};
const mapStateToProps = (state, props) => {
  return {
    value: state.form && state.form[props.name],
    error: state.form && state.form.errors && state.form.errors[props.name],
  };
};
export default connect(mapStateToProps)(Select);